import React, { useState } from "react";
import api from "../services/api";
import login from "./login.module.css";
import Navbar from "../components/Navbar.jsx";
import { useNavigate } from "react-router-dom";

const LoginPage = () => {
  const [email, setEmail] = useState("");
  const [senha, setSenha] = useState("");
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const res = await api.post("/auth/login", { email, senha });
      localStorage.setItem("token", res.data.token);
      navigate("/auth/forms");
    } catch (err) {
      alert("Login inválido");
    }
  };

  return (
    <>
      <Navbar />
      <form onSubmit={handleLogin}>
        <div class={login.form}>
          <div className={login.formulario}>
            <div className={login.title}>
              <h1>Faça Login</h1>
            </div>
            <div className={login.email}>
              <b>
                <p>Insira seu e-mail:</p>
              </b>
              <input
                type="email"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <div className={login.password}>
              <b>
                <p>Insira sua senha:</p>
              </b>
              <input
                type="password"
                placeholder="Senha"
                value={senha}
                onChange={(e) => setSenha(e.target.value)}
                required
              />
            </div>

            <div className={login.botao}>
              <button type="submit">
                <b>Entrar</b>
              </button>
            </div>
          </div>
        </div>
      </form>
    </>
  );
};

export default LoginPage;
